export const useInlineEditing = (controller, options = {}) => {
  const controllerEdit = controller.edit?.bind(controller);
  const controllerSave = controller.save?.bind(controller);
  const controllerCancel = controller.cancel?.bind(controller);
  const currentData = {}

  function onKeyTarget(target) {
    return (evt) => {
      if(evt.code === "Enter") {
        target.blur();
        evt.preventDefault();
        evt.stopPropagation();
      }
    }
  }

  function edit(...args) {
    options.targets.forEach(targetName => {
      const target = controller.targets.findTarget(targetName)
      currentData[targetName] = target.textContent
      target.contentEditable = true;
      target.addEventListener("keydown", onKeyTarget(target))
    })

    if(controllerEdit) return controllerEdit(...args)
  }

  function cancel(...args) {
    options.targets.forEach(targetName => {
      const target = controller.targets.findTarget(targetName)
      target.textContent = currentData[targetName]
      target.removeEventListener("keydown", onKeyTarget(target))
      target.contentEditable = false;
    })

    if(controllerCancel) return controllerCancel(...args)
  }

  function save(...args) {
    options.targets.forEach(targetName => {
      const target = controller.targets.findTarget(targetName)
      target.removeEventListener("keydown", onKeyTarget(target))
      target.contentEditable = false;
    })

    if(controllerSave) return controllerSave(...args)
  }

  Object.assign(controller, { save, edit, cancel })
}
